import { render, staticRenderFns } from "./DetailsContent.vue?vue&type=template&id=6f2eb64a&scoped=true&"
import script from "./DetailsContent.vue?vue&type=script&lang=js&"
export * from "./DetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsContent.vue?vue&type=style&index=0&id=6f2eb64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2eb64a",
  null
  
)

export default component.exports